let baseApiConfig;
const apiEnv = process.env.API_ENV;
if (apiEnv === 'dev') {
    baseApiConfig = require("./BaseApiConfig");
    baseApiConfig = require("./BasePredApiConfig");
    console.log("use configuration: dev")
} else if (apiEnv === 'offline') {
    baseApiConfig = require("./BaseOfflineApiConfig");
    console.log("use configuration: offline")
} else {
    baseApiConfig = require("./BasePredApiConfig");
    console.log("use configuration: pred")
}
// baseApiConfig = require("./BaseOfflineApiConfig");


const config = {
    //图片服务地址
    ImageService: `https://image2.yipuda.cn`,
    //全部扣款账单
    deductionList: `${baseApiConfig.RiderOrderprocess}/orderprocess/HcRiderDeduction/deductionList`,
    //查询骑手信息编辑
    queryRiderManages: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcRiderController/queryRiderManages`,
    //可申诉扣款账单
    deductionListCan: `${baseApiConfig.RiderOrderprocess}/orderprocess/HcRiderDeduction/deductionListCan`,
    //账单详情
    BillDetails: `${baseApiConfig.RiderOrderprocess}/orderprocess/BillingDetailsController/BillDetails`,
    //我的评价
    mycomments: `${baseApiConfig.RiderOrderhistory}/orderHistory/RiderCommentsController/comments`,
    //骑手账本
    riderBook: `${baseApiConfig.RiderOrderprocess}/orderprocess/RiderBooklController/riderBook`,
    //骑手日订单
    todayOrderDetails: `${baseApiConfig.RiderOrderhistory}/orderHistory/HcRiderTodayOrderDetails/todayOrderDetails`,
    //骑手日订单无效单
    InvalidOrder: `${baseApiConfig.RiderOrderhistory}/orderHistory/HcRiderTodayOrderDetails/InvalidOrder`,
    //骑手月订单无效单
    YueInvalidOrder: `${baseApiConfig.RiderOrderhistory}/orderHistory/HcRiderMonthOrderDetails/InvalidOrder`,
    //骑手月订单
    monthOrderDetails: `${baseApiConfig.RiderOrderhistory}/orderHistory/HcRiderMonthOrderDetails/monthOrderDetails`,
    //骑手月账单
    yuezhangdan: `${baseApiConfig.RiderOrderprocess}/orderprocess/RiderBooklController/yuezhangdan`,
    //骑手账本余额流水
    yueliushui: `${baseApiConfig.RiderOrderprocess}/orderprocess/RiderBooklController/yueliushui`,
    //提现按钮
    CashWithdrawal: `${baseApiConfig.RiderOrderprocess}/orderprocess/RiderOperation/CashWithdrawal`,

    //超级骑手-订单列表
    //sSuperRiderOrderList: `http://192.168.1.156:8763/TodayOrderController/getList`,
    SuperRiderOrderList: `${baseApiConfig.RiderOrderprocess}/TodayOrderNewController/getViceOrderList`,
    // 新骑手日订单
    getRiderOrderList: `${baseApiConfig.RiderOrderprocess}/TodayOrderNewController/getRiderOrderList`,

    //超级骑手查询订单缓存
    SuperRiderNewOrderList: `${baseApiConfig.RiderOrderprocess}/TodayOrderNewController/getList`,
    //查询商家是否已出餐
    // Diningout: `http://192.168.1.199:8763/TodayOrderNewController/Diningout`,
    Diningout: `${baseApiConfig.RiderOrderprocess}/TodayOrderNewController/Diningout`,
    //超级骑手查询name
    queryRider: `${baseApiConfig.RiderOrderhistory}/orderHistory/queryRider`,
    // 骑手推送
    outPushChange: `${baseApiConfig.RiderOrderprocess}/orderProcess/HcRiderController/outPushChange`,
    getDisconnectRider: `${baseApiConfig.RiderOrderprocess}/TodayOrderNewController/getDisconnectRider`,
    //超级骑手-订单退款
    orderRefund: `${baseApiConfig.CenterGeneral}/centergeneral/TuiKuanController/tuikuan`,
    // 超级骑手-快递站点入驻-站点列表
    getAllExpressAddress: `${baseApiConfig.BackMerchantManagementImportant}/backstageimportant/ExpressAddressController/getAllExpressAddress`,
    // 超级骑手-快递站点入驻-新增
    addExpressAddress: `${baseApiConfig.BackMerchantManagementImportant}/backstageimportant/ExpressAddressController/addExpressAddress`,
    // // 超级骑手-快递站点入驻-修改
    updateExpressAddress: `${baseApiConfig.BackMerchantManagementImportant}/backstageimportant/ExpressAddressController/updateExpressAddress`,
    // // 超级骑手-快递站点入驻-删除
    delExpressAddress: `${baseApiConfig.BackMerchantManagementImportant}/backstageimportant/ExpressAddressController/delExpressAddress`,

    //退款记录-订单退款
    orderRefunds: `${baseApiConfig.CenterImportant}/important-service/OrderRefund/Refund`,
    // 订单退款(直接退还到用户)
    CenterOrderRefund: `${baseApiConfig.CenterImportant}/important-service/OrderRefund/Refund`,
    SubMchOrderRefund: `${baseApiConfig.MemeberImportant}/wechat_ecommerce/subm_merchants/wxWechatPayRefund`,
    huifuOrderRefund: `${baseApiConfig.MemeberImportant}/V3TradePaymentScanpayRefund`,
    huifuOrderRefundQuery: `${baseApiConfig.MemeberImportant}/V3TradePaymentScanpayRefundQuery`,
    CenterHuifuOrderRefund: `${baseApiConfig.CenterImportant}/HuifuOrderRefundController/Refund`,
    //后台订单详情
    BackOrderDetails: `${baseApiConfig.MarketGeneral}/NormalBusiness/HcOrderController/details`,
    //退款记录-订单退款
    orderUnRefunds: `${baseApiConfig.BackMerchantManagementImportant}/backstageimportant/TodayOrderController/changeTradingStatus`,
    //骑手转单数量更改
    riderTransferChange:'${baseApiConfig.BackMerchantManagementImportant}/Important/RiderRuleController/editRiderRule',
    //退款记录订单数量、
    not2refund:`${baseApiConfig.RiderOrderhistory}/orderHistory/tuikuanNowCountByRedis`,
    //退款记录-订单列表
    // SuperRiderOrderLists: `${baseApiConfig.RiderOrderprocess}/TodayOrderController/getLists`,
    SuperRiderOrderLists: `${baseApiConfig.RiderOrderprocess}/TodayOrderNewController/SuperRiderOrderRefund`,
    //商家列表
    BackMarketList: `${baseApiConfig.MarketGeneral}/NormalBusiness/HcMarketController/ctrl`,
    //商家开关店
    BackMarketOpen: `${baseApiConfig.BackMerchantManagementImportant}/Important/MarketManageController/zhuanhuan`,
    //商家显示隐藏店铺
    BackMarketHideShop: `${baseApiConfig.RiderOrderhistory}/orderHistory/MarketManageController/UpdateMarketHide`,
    //商家店铺状态修改
    BackMarketHideStatus: `${baseApiConfig.BackMerchantManagementImportant}/Important/MarketManageController/query-hide`,
    // 后台>补贴活动管理>满减补贴活动 List
    BackFullSubsidiesList: `${baseApiConfig.BackMerchantManagementImportant}/Important/SubsidyActivitiesController/GetFullSubsidiesList`,
    //后台>补贴活动管理>满减补贴活动>新建代理商自助补贴
    AgentSubsidiesAdd: `${baseApiConfig.BackMerchantManagementImportant}/Important/SubsidyActivitiesController/AddAgentSubsidies`,
    // 后台>补贴活动管理>满减补贴活动>撤销
    FullSubsidiesRevoke: `${baseApiConfig.BackMerchantManagementImportant}/Important/SubsidyActivitiesController/FullSubsidiesRevoke`,
    //后台>推送商家列表
    ActivityPush: `${baseApiConfig.BackMerchantManagementImportant}/Important/SubsidyActivitiesController/ActivityPush`,
    //后台>推送商家列表>单个 推/不推
    SinglePush: `${baseApiConfig.BackMerchantManagementImportant}/Important/SubsidyActivitiesController/SinglePush`,
    //后台>推送商家列表>获取满减活动
    getfullreduce: `${baseApiConfig.BackMerchantManagementImportant}/Important/SubsidyActivitiesController/getfullreduce`,
    //后台>推送商家列表>检查满减活动
    checkReduce: `${baseApiConfig.MarketImportant}/ImportantBusiness/HcSubController/checkReduce`,
    //后台>推送商家列表>发布满减活动
    fabureduce: `${baseApiConfig.MarketImportant}/ImportantBusiness/HcSubController/AddRegistrationActivities`,
    //后台>推送商家列表>UpdateSignUpInfo
    UpdateSignUpInfo: `${baseApiConfig.MarketImportant}/ImportantBusiness/HcSubController/UpdateSignUpInfo`,
    // 后台>补贴活动管理>满减补贴活动>活动报表>暂停
    StartNow: `${baseApiConfig.BackMerchantManagementImportant}/Important/SubsidyActivitiesController/StartNow`,
    // 后台>补贴活动管理>满减补贴活动>编辑>查询回显
    SelectBackFill: `${baseApiConfig.BackMerchantManagementImportant}/Important/SubsidyActivitiesController/SelectBackFill`,
    // 后台>补贴活动管理>满减补贴活动>编辑
    EditContent: `${baseApiConfig.BackMerchantManagementImportant}/Important/SubsidyActivitiesController/EditContent`,
    // 后台>补贴活动管理>满减补贴活动>活动报表>驳回
    RegistrationReject: `${baseApiConfig.BackMerchantManagementImportant}/Important/SubsidyActivitiesController/RegistrationReject`,
    // 后台>补贴活动管理>满减补贴活动>活动报表>暂停
    RegistrationSuspend: `${baseApiConfig.BackMerchantManagementImportant}/Important/SubsidyActivitiesController/RegistrationSuspend`,
    // 后台>补贴活动管理>满减补贴活动>活动报表
    BackRegistrationList: `${baseApiConfig.BackMerchantManagementImportant}/Important/SubsidyActivitiesController/RegistrationList`,
    // 后台>补贴活动管理>满减补贴活动>活动报表>驳回编辑查询回显
    RejectSelect: `${baseApiConfig.BackMerchantManagementImportant}/Important/SubsidyActivitiesController/RejectSelect`,
    //后台商家银行卡信息提交
    BackMarketBankUp: `${baseApiConfig.BackMerchantManagementImportant}/Important/MarketManageController/update`,
    //后台商家银行卡信息
    BackMarketBank: `${baseApiConfig.BackMerchantManagementImportant}/Important/MarketManageController/ctrl`,
    // 后台商家资质信息
    BackMarketCerInfo: `${baseApiConfig.BackMerchantManagementImportant}/Important/ZiZhiController/ctrl`,
    //商家价格设定
    BackMarketBlind: `${baseApiConfig.RiderOrderhistory}/orderHistory/MarketManageController/query-delivery`,
    //商家价格修改
    BackMarketModification: `${baseApiConfig.RiderOrderhistory}/orderHistory/MarketManageController/update`,
    // 商家转自配送
    BackMarketToSelf: `${baseApiConfig.BackMerchantManagementImportant}/Important/MarketToSelfDistribution/toSelf`,
    // 商家配送修改拒绝
    BackMarketReject: `${baseApiConfig.BackMerchantManagementImportant}/Important/MarketToSelfDistribution/reject`,
    // 商家转配送
    BackMarketToHeyi: `${baseApiConfig.BackMerchantManagementImportant}/Important/MarketToSelfDistribution/toHeyi`,
    // 商家配送方式申请列表
    BackMarketSelfList: `${baseApiConfig.BackMerchantManagementImportant}/Important/MarketToSelfDistribution/ctrl`,
    //后台商家入驻审核
    BackMarketPass: `${baseApiConfig.BackMerchantManagementImportant}/Important/MarketManageController/pass`,
    //后台商家入驻列表
    BackMarketEnterList: `${baseApiConfig.BackMerchantManagementImportant}/Important/EnterController/list`,
    //后台>推送商家列表>勾选推送
    AllPush: `${baseApiConfig.BackMerchantManagementImportant}/Important/SubsidyActivitiesController/Push`,
    //后台地图>城市地图初始化
    cityMapIndex: `${baseApiConfig.BackMerchantManagementImportant}/Important/BackStageMap/cityMapIndex`,
    //后台地图>商家信息
    shopMapInformation: `${baseApiConfig.BackMerchantManagementImportant}/Important/BackStageMap/shopMapInformation`,
    //后台地图>骑手信息
    riderMapInformation: `${baseApiConfig.BackMerchantManagementImportant}/Important/BackStageMap/riderMapInformation`,
    //后台地图>骑手订单信息
    riderParticulars: `${baseApiConfig.BackMerchantManagementImportant}/Important/BackStageMap/riderParticulars`,
    //后台地图>语音单商家信息
    runningErrandsOrders: `${baseApiConfig.BackMerchantManagementImportant}/Important/BackStageMap/runningErrandsOrders`,
    //后台地图>展示未接订单列表
    riderOrderShow: `${baseApiConfig.BackMerchantManagementImportant}/Important/BackStageMap/riderOrderShow`,
    //后台地图》骑手路线初始化.
    centerCity: `${baseApiConfig.BackMerchantManagementImportant}/Important/RiderRoute/centerCity`,
    //后台地图》骑手路线初始化>获取坐标
    shopMap: `${baseApiConfig.BackMerchantManagementImportant}/Important/RiderRoute/shopMap`,
    //后台地图》骑手路线初始化>获取骑手坐标
    riderApply: `${baseApiConfig.BackMerchantManagementImportant}/Important/RiderDynamicController/apply`,
    //地图展示商家和收货坐标
    getOrderLocation: `${baseApiConfig.RiderOrderprocess}/TodayOrderController/getOrder`,

    //订单详情
    detailsList: `${baseApiConfig.RiderOrderprocess}/TodayOrderController/detailsList`,
    //订单详情 传图
    chuanTu: `${baseApiConfig.RiderOrderprocess}/TodayOrderController/chuanTu`,
    //显示订单图片
    pictureDetail: `${baseApiConfig.RiderOrderprocess}/TodayOrderController/pictureDetail`,
    //骑手发送订单图片
    RiderImgUpload:`${baseApiConfig.RiderOrderprocess}/TodayOrderController/riderImgUpload`,
    UploadUnlimited: `${baseApiConfig.MemeberImportant}/UploadUnlimited/upload`,
    //骑手列表
    riderList: `${baseApiConfig.BackMerchantManagementImportant}/Important/Dispatchcontroller/riderPageNew`,
    // riderList:"http://192.168.2.7:8995/Important/Dispatchcontroller/riderPageNew",
    //派单接口
    PaiDan: `${baseApiConfig.RiderOrderprocess}/TodayOrderController/paidan`,
    //新派单接口

    SuperRiderPaiDan : `${baseApiConfig.RiderOrderprocess}/TodayOrderController/SuperRiderPaiDan`,

    //城市开关-获取
    BackServiceShopInfo: `${baseApiConfig.BackMerchantManagementImportant}/backstageimportant/HcCityManageOffOrOpenController/OffManageInfo`,
    //城市开关-更改
    BackServiceShop: `${baseApiConfig.BackMerchantManagementImportant}/backstageimportant/HcCityManageOffOrOpenController/OffManage`,
    // 是否自动派单
    backOpenOrClose: `${baseApiConfig.BackMerchantManagementImportant}/Important/deleviry/openOrClose`,
    //配送范围开关
    BackDistributionScopeOff: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcMemberController/distributionScopeOff`,
    //地区骑手抢单开关
    BackGrabSheetOff: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcMemberController/grabSheetOff`,
    //后台地区管理查询
    BackAddressManage: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcMemberController/ListQueryCity`,
    //后台距离收费页面查询
    QueryFreight: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcFreightController/freightQuery`,
    //后台距离收费曲线管理页面查询
    CurveManagementQuery: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcFreightController/CurveManagementQuery`,
    //后台距离收费曲线管理 编辑
    CurveManagementUpdate: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcFreightController/CurveManagementUpdate`,
    //后台距离收费曲线管理 添加
    CurveManagementInsert: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcFreightController/CurveManagementInsert`,
    //后台距离收费曲线管理 删除
    CurveManagementDelete: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcFreightController/CurveManagementDelete`,

    //意见反馈
    selectMessageList: `${baseApiConfig.BackMerchantManagementImportant}/backstageimportant/MessageManagementController/selectMessageList`,
    //   selectMessageList:`http://192.168.1.41:8995/backstageimportant/MessageManagementController/selectMessageList`,
    //回复反馈消息
    replyMessage: `${baseApiConfig.BackMerchantManagementImportant}/backstageimportant/MessageManagementController/replyMessage`,
    // replyMessage: `http://192.168.1.41:8995/backstageimportant/MessageManagementController/replyMessage`,
    //获取验证码
    SendSMSCode: `${baseApiConfig.MarketImportant}/WechatPushBindingController/sendSMS`,
    //获取验证码（新）
    NewSendSMSCode: `${baseApiConfig.MarketImportant}/WechatPushBindingController/newSendSMS`,
    // 微信推送绑定-
    WechatPushBind: `${baseApiConfig.MarketImportant}/WechatPushBindingController/bind`,
    // 微信推送绑定（新） ：获取openid+插入库
    NewWechatPushBind: `${baseApiConfig.MemeberImportant}/ApiWeChatSubscription/authorize`,
    selectRirderByMobile: `${baseApiConfig.RiderOrderprocess}//orderProcess/HcRiderController/selectRirderByMobile`,

    //后台骑手管理页面的审核的查询
    RiderManageShenHeQuery: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcRiderController/apply`,
    //RiderManageShenHeQuery: `http://192.168.1.156:8995/Important/HcRiderController/apply`,
    //骑手审核通过/拒绝
    RiderShenHePassOrNo: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcRiderColler/pass`,
    //RiderShenHePassOrNo: `http://192.168.1.156:8995/Important/HcRiderColler/pass`,
    //设置骑手是否显示订单金额详情
    riderOrderAmount: `${baseApiConfig.BackMerchantManagementImportant}/Important/orderAmount`,
    //骑手删除
    BackRiderrefund: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcRiderController/refund`,
    //BackRiderrefund: `http://192.168.1.156:8995/backstageimportant/Important/HcRiderController/refund`,
    //后台骑手列表
    //BackRiderList: `http://192.168.1.156:8763/Rider/RiderListController/ctrl`,
    BackRiderList: `${baseApiConfig.RiderOrderprocess}/Rider/RiderListController/ctrl`,
    //骑手信息
    RiderInformation: `${baseApiConfig.RiderOrderprocess}/orderProcess/HcRiderController/riderInformation`,
    //注销
    Cancellation: `${baseApiConfig.RiderOrderprocess}/orderProcess/HcRiderController/Cancellation`,
    // Cancellation:`http://127.0.0.1:8763/orderProcess/HcRiderController/Cancellation`,
    //发短信
    SendMsg: `${baseApiConfig.CenterImportant}/centerimportant/SendMsg/Cancellation`,
    VueAutoUpload: `${baseApiConfig.BackMerchantManagementImportant}/Important/ImageUpload/VueAutoUpload`,
    /**
     * 从图库中获取快递代取logo图片
     */
    addPicExpressAddress: `${baseApiConfig.BackMerchantManagementImportant}/backstageimportant/ExpressAddressController/addPicExpressAddress`,

    //获取能干的骑手
    getRiderList: `${baseApiConfig.BackMerchantManagementImportant}/backstageimportant/TodayOrderController/getRiderList`,

    //获取地图信息
    getMarketLocation: `${baseApiConfig.RiderOrderhistory}/orderHistory/RiderMap/getMarketLocation`,
    //上报到店
    sbdd: `${baseApiConfig.RiderOrderprocess}/orderprocess/HcOrderController/order`,

    //完成取货
    wcqh: `${baseApiConfig.RiderOrderprocess}/orderprocess/RiderTarkOrderController/select`,

    //完成派单
    wcpd: `${baseApiConfig.RiderOrderprocess}/orderprocess/RiderCompleteController/add`,
    //待取货 新任务 配送中
    daiquhuo: `${baseApiConfig.RiderOrderprocess}/orderprocess/HcRiderOrderController/rider_controller`,

    //接单
    jiedan: `${baseApiConfig.RiderOrderprocess}/orderprocess/RiderGetOrderController/select`,
    //推荐单
    tuijiandan: `${baseApiConfig.RiderOrderprocess}/orderprocess/RiderRecommendController/recommendList`,
    //抢单
    qiangdan: `${baseApiConfig.RiderOrderprocess}/orderprocess/RiderGrabController/recommendClick`,
    // 骑手今天全部订单
    today_all_order:  `${baseApiConfig.RiderOrderprocess}/orderprocess/HcRiderOrderController/rider_all_order`,
    // 订单详情
    orderDetails: `${baseApiConfig.RiderOrderprocess}/orderprocess/RiderSituationController/situation`,
    // 推荐单地图 里面的推荐单
    tuijiandan_map: `${baseApiConfig.RiderOrderprocess}/orderprocess/TuiJianDetailsController/selectDetails`,
    //骑手转单列表
    single: `${baseApiConfig.RiderOrderprocess}/orderprocess/HcRiderSingleController/Single`,
    //转单
    changeOrder: `${baseApiConfig.RiderOrderprocess}/orderprocess/RiderChangeOrderController/changeOrder`,
    //骑手订单排行
    orderRanking: `${baseApiConfig.RiderOrderhistory}/orderHistory/HcRiderTodayOrderDetails/riderOrderRanking`,
    //活动中心明细
    bountyDetails:`${baseApiConfig.CenterGeneral}/RiderPropagandaController/bounty/details`,
    //活动中心-任务列表
    riderTaskList:`${baseApiConfig.CenterGeneral}/RiderPropagandaController/riderTaskList`,
    //活动中心-任务领取
    claimActivity:`${baseApiConfig.CenterGeneral}/RiderPropagandaController/claim/activity`,
    //活动中心-上传凭证
    uploadActivity:`${baseApiConfig.CenterGeneral}/RiderPropagandaController/upload/activity`,
    //活动中心-查看超级骑手是否为宣传员
    isPropagandist:`${baseApiConfig.BackMerchantManagementImportant}/Important/is/propagandist`,

    //骑手日订单 修正订单
    xiuzheng_ridingdan: `${baseApiConfig.RiderOrderhistory}/orderHistory/HcRiderTodayOrderDetails/xiuzheng_zongdanshu`,


    getCity:`${baseApiConfig.RiderOrderhistory}/orderHistory/Selectcity/list`, //骑手模糊查询城市名

    getCityByName:`${baseApiConfig.RiderOrderhistory}/orderHistory/Selectcity/getCityByName`, //模糊查询获取城市列表

    getMarketDeliery:`${baseApiConfig.RiderOrderhistory}/orderHistory/Selectcity/getCityByName`,//查询商家对应的起送价
    Unbinding: `${baseApiConfig.MarketGeneral}/NormalBusiness/Unbinding`,
    MarketFinanceIndex: `${baseApiConfig.MarketImportant}/ImportantBusiness/ActiveController/index`, //更换提现方式
    MarketFinanceGetInformationImg: `${baseApiConfig.MarketGeneral}/NormalBusiness/InformationIntegrityController/getInformationImg`, // 财务管理 - 解绑
    GetMarketWXPush: `${baseApiConfig.MarketImportant}/ImportantBusiness/market/GetMarketWXPush`,
    //查看余额流水
    MarketFinanceIntoBook: `${baseApiConfig.MarketImportant}/ImportantBusiness/ActiveController/intoBookStream`, //流水入账详情
    MarketFinanceHstoricalBill: `${baseApiConfig.MarketImportant}/ImportantBusiness/ActiveController/hstoricalBill`, //商家结算  选择账单
    MarketFinanceSettlement: `${baseApiConfig.MarketImportant}/ImportantBusiness/ActiveController/settlementStream`, //历史账单
    MarketFinanceIntoBookDetail: `${baseApiConfig.MarketImportant}/ImportantBusiness/ActiveController/intoBookStreamBillDetail`, //账单明细
    //财务管理>外卖账户管理>结算>提现金额列表
    AgentIntoBookInfo: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcFinanceController/AgentIntoBook`,
    //财务管理>外卖账户管理>结算
    SettlementMoney: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcFinanceController/SettlementMoney`,
    //财务管理>外卖账户管理>可结算余额
    BackAgentIntoBookBalance: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcFinanceController/GetAgentIntoBookBalance`,
    //财务管理> 联盟红包财务流水>List
    AllianceRedpackFinanceList: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcFinanceController/AllianceRedpackFinanceList`,
    CenterUserBankInfo: `${baseApiConfig.CenterImportant}/centerImportant/FinancialController/selectBankCard`,

    WeatherSurchargeQuery: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcFreightController/WeatherSurchargeQuery`,
    WeatherSurchargeUpdate: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcFreightController/WeatherSurchargeUpdate`,
    WeatherSurchargeInsert: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcFreightController/WeatherSurchargeInsert`,
    WeatherSurchargeDelete: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcFreightController/WeatherSurchargeDelete`,
    UpadateEnableDisweather: `${baseApiConfig.BackMerchantManagementImportant}/Important/HcFreightController/UpadateEnableDisweather`,
    addRecords: `${baseApiConfig.BackMerchantManagementImportant}/Important/RecordsController/addRecords`,
    UploadPicAction: `${baseApiConfig.BackMerchantManagementImportant}/Important/ImageUpload/VueAutoUploadLoge11`,
    //店铺环境
    addMarketUpload: `${baseApiConfig.BackMerchantManagementImportant}/MarketUploadPic/add`,
    listMarketUpload: `${baseApiConfig.BackMerchantManagementImportant}/MarketUploadPic/list`,
    BackMarketSee: `${baseApiConfig.BackMerchantManagementImportant}/Important/MarketManageController/edit`,

    //月周日报
    FoodInspectionMonthList: `${baseApiConfig.RiderOrderprocess}/HeguiController/FoodInspectionMonthList`,
    FoodInspectionWeekList: `${baseApiConfig.RiderOrderprocess}/HeguiController/FoodInspectionWeekList`,
    FoodInspectionDayList: `${baseApiConfig.RiderOrderprocess}/HeguiController/FoodInspectionDayList`,
    FoodInspectionMonthAdd: `${baseApiConfig.RiderOrderprocess}/HeguiController/FoodInspectionMonthAdd`,
    FoodInspectionWeekAdd: `${baseApiConfig.RiderOrderprocess}/HeguiController/FoodInspectionWeekAdd`,
    FoodInspectionDayAdd: `${baseApiConfig.RiderOrderprocess}/HeguiController/FoodInspectionDayAdd`,
    FoodSafetyExam: `${baseApiConfig.RiderOrderprocess}/HeguiController/FoodSafetyExam`,
    CityFoodSafetyExam: `${baseApiConfig.RiderOrderprocess}/HeguiController/CityFoodSafetyExam`,
    //重置商家密码或手机号
    BackUpdatePasswordByShopMobile: `${baseApiConfig.BackMerchantManagementImportant}/backstageimportant/HcMarketController/BackUpdatePasswordByShopMobile`,
    //后台-->系统设置-->地区管理-->编辑地图-->查询城市
    cityMapIndexXX: `${baseApiConfig.BackMerchantManagementImportant}/Important/DistrictManagementMap/cityMapIndexXX`,
    //后台-->系统设置-->地区管理-->编辑地图-->查询坐标
    BuzyMap: `${baseApiConfig.BackMerchantManagementImportant}/Important/DistrictManagementMap/BuzyMap`,
};
module.exports = config;




// WEBPACK FOOTER //
// ./src/ApiConfig.js